import React, { createContext, useContext, useState, useCallback } from 'react';

// crumbs: array of { label: string, path: string|null }
// path null = current page (not clickable)

const BreadcrumbContext = createContext({ crumbs: [], setBreadcrumb: () => {}, clearBreadcrumb: () => {} });

export function BreadcrumbProvider({ children }) {
  const [crumbs, setCrumbs] = useState([]);

  const setBreadcrumb = useCallback((newCrumbs) => {
    setCrumbs(newCrumbs);
  }, []);

  const clearBreadcrumb = useCallback(() => {
    setCrumbs([]);
  }, []);

  return (
    <BreadcrumbContext.Provider value={{ crumbs, setBreadcrumb, clearBreadcrumb }}>
      {children}
    </BreadcrumbContext.Provider>
  );
}

export function useBreadcrumb() {
  return useContext(BreadcrumbContext);
}
